export default {
    DRAG: 'drag',
    VERSION: 'version',
    HELP: 'help',
    TURBO: 'turbo',
    MIN_ROUND_DURATION: 'min_round_duration',
    RESTRICT_ROUND_CELEBRATIONS: 'restrict_round_celebrations',
    MIN_ROUND_DURATION_STRICT: 'min_round_duration_strict',
    SKIP_ANIMATION: 'skip_animation',
    TURBO_SPIN: 'turbo_spin',
    WIN_RATES: 'win_rates',
    WHEEL_WIN_ONLY: 'wheel_win_only',
    MAX_MULTIPLIER_TEXT: 'max_multiplier_text',
    MAX_MULTIPLIER_WIN_LINES: 'max_multiplier_win_lines',
    PAYOUT_EXAMPLE_TEXT_NO_MULTILINE: 'payout_example_text_no_multiline',
    GAME_SESSION: 'game_session',
    STOP_AUTOPLAY: 'stop_autoplay',
    HAS_STOP: 'has_stop',
    HIDE_TURBO_TOOLTIP: 'hide_turbo_tooltip',
    HELP_MAX_MULTIPLIER: 'help_max_multiplier',
    FEATURE_BUY_COMFIRMATION: 'feature_buy_confirmation',
    FORCE_RESOLUTION: 'force_resolution',
    HELP_ADDITIONAL_EXPLANATION: 'help_additional_explanation',
    PAYTABLE_DYNAMIC_PAYOUTS: 'paytable_dynamic_payouts',
    MAX_WIN_PROBABILITY: 'max_win_probability',
    CUSTOM_LANGUAGE: 'custom_language',
    FEATURE_BUY_VERSION: 'feature_buy_version',
    VOLATILITY_INDEX: 'volatility_index',
    DOUBLE_REBET_PROMPT: 'double_rebet_prompt',
    DEFAULT_STAKE: 'default_stake',
    REGULATION_RTP: 'regulation_rtp',
    PAYTABLE_SHOW_PAYOUTS: 'PAYTABLE_SHOW_PAYOUTS',
    HELP_TABLE_CONTROLS: 'help_table_controls',
};
